import React from 'react';
function Basket(){
    return<h1> Basket</h1>
}

export default Basket;